import React from 'react';
import './App.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';

import { Grid } from "@mui/material";
import Pagina from "./Pagina/Pagina";
import RouteLoadingWrapper from "./Pagina/Secciones/Componentes/RouteLoadingWrapper";
import { BrowserRouter as Router } from 'react-router-dom';

function App() {
    return (
        <Router>
            <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                sx={{ width: "100%", minHeight: "100vh" }}
            >
                <RouteLoadingWrapper>
                    <Pagina />
                </RouteLoadingWrapper>
            </Grid>
        </Router>
    );
}

export default App;
